<template>
<transition name="z-confirm-fade">
  <div v-if='!!value'>
        <div class="zMessageBg" style="display:block"></div>
        <div class="zMessageBox" :class="[size ? 'z-Message-' + size : '']">
        <div class="top" v-mousetop><span>{{title}}</span><div v-if="noClose == true" class="close" @click="close">×</div></div>
        <slot></slot>
        </div>
  </div>
</transition>
</template>
<script>
/* eslint-disable */
export default {
  props: {
    show: Boolean,
    title: "",
    size: "",
    noClose: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      value: this.show
    };
  },
  watch: {
    show(newVal) {
      newVal ? (this.value = true) : (this.value = false);
    }
  },
  directives: {
    mousetop: {
      inserted: function(el) {
        var oDiv = el;
        oDiv.onmousedown = function(ev) {
          var disX = ev.clientX - oDiv.parentNode.offsetLeft;
          var disY = ev.clientY - oDiv.parentNode.offsetTop;
          document.onmousemove = function(ev) {
            var l = ev.clientX - disX;
            var t = ev.clientY - disY;
            oDiv.parentNode.style.left = l + "px";
            oDiv.parentNode.style.top = t + "px";
            oDiv.parentNode.style.marginLeft = "0";
            oDiv.parentNode.style.marginTop = "0";
          };
          document.onmouseup = function() {
            document.onmousemove = null;
            document.onmouseup = null;
          };
        };
      }
    }
  },

  methods: {
    close() {
      this.value = false;
      this.$emit("close");
    }
  }
};
</script>

<style>
.zMessageBg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #000;
  opacity: 0.1;
  z-index: 98;
  display: none;
}
.zMessageBox {
  width: 826px;
  margin-left: -430px;
  background-color: rgba(238, 238, 238, 1);
  position: fixed;
  top: 130px;
  left: 50%;
  padding-bottom: 20px;
  background-color: #fff;
  z-index: 99;
  border-radius: 6px;
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.2);
}
.z-Message-shipment {
  width: 926px;
  height: 600px;
  overflow: hidden;
}
.z-Message-address {
  width: 600px;
  height: 480px;
  margin-left: -300px;
  overflow: hidden;
}
.z-Message-return {
  width: 840px;
  height: 770px;
  overflow: hidden;
}
.z-Message-confirm {
  width: 350px;
  overflow: hidden;
  margin-left: -175px;
  top: 30%;
}
.zMessageBox .top {
  height: 42px;
  background-color: #f5f5f5;
  width: 100%;
  border-radius: 2px 2px 0 0;
  cursor: move;
  text-align: left;
}
.zMessageBox .top span {
  margin-left: 20px;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
}
.zMessageBox .close {
  position: absolute;
  top: 0;
  right: 0;
  font-size: 28px;
  color: #999;
  width: 42px;
  height: 42px;
  text-align: center;
  cursor: pointer;
  z-index: 6;
  font-weight: inherit;
  line-height: 42px;
  transition: 1s ease-in-out 0s;
  -moz-transition: 1s ease-in-out 0s;
  -webkit-transition: 1s ease-in-out 0s;
  -o-transition: 1s ease-in-out 0s;
  -webkit-backface-visibility: hidden;
}
.zMessageBox .close:hover {
  -moz-transform: scale(1.1) rotate(360deg);
  -webkit-transform: scale(1) rotate(360deg);
  -webkit-transform-origin: 50% 50%;
  -moz-transform-origin: 50% 50%;
  -moz-transition: 1s ease-in-out 0s;
  -webkit-transition: 1s ease-in-out 0s;
}
.z-confirm-fade-enter-active {
  transition: all 0.1s ease;
}
.z-confirm-fade-leave-active {
  transition: all 0.4s cubic-bezier(1, 0.5, 0.8, 1);
}
.z-confirm-fade-enter,
.z-confirm-fade-leave-active {
  opacity: 0;
}
</style>